var BetHistoryFilterTypes;
(function (BetHistoryFilterTypes) {
    BetHistoryFilterTypes[BetHistoryFilterTypes["Lose"] = 0] = "Lose";
    BetHistoryFilterTypes[BetHistoryFilterTypes["Win"] = 1] = "Win";
    BetHistoryFilterTypes[BetHistoryFilterTypes["All"] = 2] = "All";
})(BetHistoryFilterTypes || (BetHistoryFilterTypes = {}));
var betHistoryPagingDisable;
(function (betHistoryPagingDisable) {
    betHistoryPagingDisable["NEXT"] = "next";
    betHistoryPagingDisable["PREV"] = "prev";
    betHistoryPagingDisable["ALL"] = "all";
})(betHistoryPagingDisable || (betHistoryPagingDisable = {}));

export { BetHistoryFilterTypes, betHistoryPagingDisable };
